module.exports = __webpack_public_path__ + "e43b29eefea21850653b3bee9a4222ac.png";